import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttributeValidationError } from '../../section-instance/attribute-rows/attribute-number-edit-row/attribute-number-edit-row.component';

export function getStaticNumberError(
  value: number | null,
  isRequired: boolean,
  maxValue?: number,
): AttributeValidationError | null {
  if (value == null) {
    return isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
  }
  if (maxValue != null && value > maxValue) {
    return { key: 'COMMON.ATTRIBUTE_VALIDATION.MAX_VALUE', params: { max: maxValue } };
  }
  return null;
}

@Component({
  selector: 'lib-static-number-edit-row',
  standalone: false,
  templateUrl: './static-number-edit-row.component.html',
  styleUrls: ['./static-number-edit-row.component.scss'],
})
export class StaticNumberEditRowComponent implements OnInit {
  @Input() label: string = '';
  @Input() originalValue: number | null | undefined;
  // Undefined until the field is edited.
  @Input() value: number | null | undefined;
  @Input() isRequired: boolean = false;
  @Input() maxValue?: number;
  @Output() valueChange = new EventEmitter<number | null>();
  inputValue: number | null = null;
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    this.inputValue = (this.value === undefined ? this.originalValue : this.value) ?? null;
    this.validate(this.inputValue);
  }

  onValueChange(value: number | null) {
    this.valueChange.emit(value);
    this.validate(value);
  }

  // Unchanged values are not validated, except empty ones, so a required field that is still empty shows an error.
  private validate(value: number | null) {
    this.error = value !== null && value === (this.originalValue ?? null)
      ? null
      : getStaticNumberError(value, this.isRequired, this.maxValue);
  }
}
